import { STLLoader } from 'three/examples/jsm/loaders/STLLoader';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import {
  MeshStandardMaterial,
  Mesh,
  Color,
  Vector3,
  Box3,
  WebGLRenderer,
  Scene,
  PerspectiveCamera,
  AmbientLight,
  DirectionalLight
} from 'three';

const SimpleSTLViewerToImage = async (url) => {
  return new Promise((resolve) => {
    if (!url) {
      return resolve(createFallbackImage());
    }

    const isOBJ = url.toLowerCase().endsWith('.obj');
    const loader = isOBJ ? new OBJLoader() : new STLLoader();

    loader.load(
      url,
      (loadedData) => {
        const geometry = isOBJ ? loadedData.children[0].geometry : loadedData;

        const material = new MeshStandardMaterial({
          color: new Color(0xcccccc),
          roughness: 0.3,
          metalness: 0.9,
        });

        const mesh = new Mesh(geometry, material);

        const boundingBox = new Box3().setFromObject(mesh);
        const center = new Vector3();
        boundingBox.getCenter(center);
        geometry.translate(-center.x, -center.y, -center.z);

        const size = new Vector3();
        boundingBox.getSize(size);
        const maxAxis = Math.max(size.x, size.y, size.z);
        const scaleValue = 10 / maxAxis;
        mesh.scale.set(scaleValue, scaleValue, scaleValue);
        mesh.position.set(0, 0, 0);
        mesh.rotation.set(Math.PI / -2, 0, 0);

        const scene = new Scene();
        scene.background = new Color(0xffffff);
        scene.add(mesh);


        const camera = new PerspectiveCamera(15, 1, 0.1, 1000);
        camera.position.set(25, 25, 25); 
        camera.lookAt(0, 0, 0);

    
        const ambientLight = new AmbientLight(0xffffff, 5);
        scene.add(ambientLight);

        const directionalLight1 = new DirectionalLight(0xffffff, 1);
        directionalLight1.position.set(10, 10, 10);
        scene.add(directionalLight1);

        const directionalLight2 = new DirectionalLight(0xffffff, 0.5);
        directionalLight2.position.set(-10, -10, -10);
        scene.add(directionalLight2);

        const renderer = new WebGLRenderer({ antialias: true });
        renderer.setSize(500, 500);
        renderer.render(scene, camera);

        const dataURL = renderer.domElement.toDataURL('image/png');
        resolve(dataURL);
      },
      undefined,
      () => {
        resolve(createFallbackImage());
      }
    );
  });
};

function createFallbackImage() {
  const canvas = document.createElement('canvas');
  canvas.width = 500;
  canvas.height = 500;
  const ctx = canvas.getContext('2d');

  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.fillStyle = '#888888';
  ctx.font = '20px Arial';
  ctx.textAlign = 'center';
  ctx.fillText('Image not available', canvas.width / 2, canvas.height / 2);

  return canvas.toDataURL('image/png');
}

export default SimpleSTLViewerToImage;
